import React, { useState } from "react";
import Button from "../../Button/Button";
import InputBox from "../../Input/Input";
import Modal from "../Modal";
import "./Charity.css";
import { GetCharities } from "../../../services/charity.service";
import { IGetCharities } from "../../../types/types";

const CharityModel: React.FC<{
  isVisible?: boolean;
  handleSaveCharity?: (charityId: string) => void;
  onClose: () => void;
}> = ({ isVisible, handleSaveCharity, onClose }) => {

  const [state, setState] = useState({
    searchQuery: "",
    filteredCharities: [] as IGetCharities[],
    isListLoading: false,
    error: "",
    selectedCharity: ""
  })

  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setState((prev) => ({ ...prev, searchQuery: value, selectedCharity: "" }))

    if (!value) {
      setState((prev) => ({ ...prev, filteredCharities: [], selectedCharity: "", searchQuery: "" }))
      return;
    }

    setState((prev) => ({ ...prev, isListLoading: true }))
    try {
      const response = await GetCharities({ charity_name: value });
      if (response.error) {
        console.error("Error fetching charities", response.error);
      }

      setState((prev) => ({ ...prev, filteredCharities: response.data || [] }))
    } catch (err) {
      console.error("An error occurred", err);
    } finally {
      setState((prev) => ({ ...prev, isListLoading: false }))
    }
  };

  const validateForm = () => {
    if (!state.selectedCharity.trim()) {
      setState((prev) => ({ ...prev, error: "Please select valid charity from list." }))
      return false;
    }
    setState((prev) => ({ ...prev, error: "" }))
    return true;
  };

  const handleSubmit = async () => {
    if (validateForm() && handleSaveCharity) {
      handleSaveCharity(state.selectedCharity);
      setState((prev) => ({ ...prev, searchQuery: "", selectedCharity: "" }))
    }
  };

  const handleClose = () => {
    setState((prev) => ({ ...prev, searchQuery: "", error: "" }))
    onClose();
  };

  const handleSelect = (charity: any) => {
    setState((prev) => ({ ...prev, selectedCharity: charity.id, searchQuery: charity.charity_name }))
  }

  return (
    <Modal
      id="CharityModal"
      title="Select Charity"
      modalBackground="modal-bg boxModel"
      onClose={handleClose}
      isVisible={isVisible}
      body={
        <div className="m-4 pt-0 mt-3">
          <form className="account-form text-start">
            <InputBox
              name="charityName"
              onChange={handleChange}
              className="list-dropdown custom-label-class"
              placeholder="Search Charity From List"
              value={state.searchQuery}
            />
            {state.searchQuery && (
              <div className="charity-list mt-2">
                {state.isListLoading ? (
                  <div className="inside-loader h-100"><div className="spinner"></div></div>
                ) : state.filteredCharities.length > 0 ? (
                  state.filteredCharities.map((charity, index) => (
                    <div key={index} className="charity-item px-1" onClick={() => { handleSelect(charity) }}>{charity.charity_name}</div>
                  ))
                ) : (
                  <div className="no-results">No charities found</div>
                )}
              </div>
            )}
            {state.error && <div className="text-danger">{state.error}</div>}
            <div className="mb-1 mt-4 d-flex justify-content-center">
              <Button label={<>Save Charity</>} variant="primary" className="savebtn font-18 font-500" onClick={handleSubmit} />
            </div>

            <div className="col-12 mt-4 d-flex justify-content-center align-items-center">
              <span className="font-400 cursor-pointer removeLink text-center">
                Remove Charity <i className="fa-solid fa-trash-can"></i>
              </span>
            </div>
          </form>
        </div>
      }
    />
  );
};

export default CharityModel;
